// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3hWk4","productName":"Table_productName__1O5L1"};